<template>
  <div class="row" v-if="Object.keys(dashboardData).length">
    <div class="col-md-12">
      <div class="card mb-4 o-hidden">
        <div class="card-body">
          <div class="calendar">
            <div class="calendar-toolbar">
              <div class="calendar-toolbar__title">
                <i class="far fa-calendar-alt"></i>
                <span>{{ $t('Calenderlist.text') }}</span>
              </div>
              <button type="button" class="calendar-today-btn" @click="goToToday">
                {{ $i18n.locale == 'ar' ? 'اليوم' : 'Today' }}
              </button>
            </div>
            <div class="calendar-navigation">
              <button type="button" class="calendar-navigation__arrow" @click="changeMonth(-1)">
                <i class="fas fa-chevron-right"></i>
              </button>
              <span class="calendar-navigation__title">{{ currentPageTitle }}</span>
              <button type="button" class="calendar-navigation__arrow" @click="changeMonth(1)">
                <i class="fas fa-chevron-left"></i>
              </button>
            </div>
            <Calendar
                ref="calendar"
                class="custom-calendar max-w-full"
                :locale="$i18n.locale"
                @did-move="pageChange"
                :first-day-of-week="dayIndex"
                :masks="masks"
                :attributes="filterEvents"
                disable-page-swipe
                trim-weeks
                is-expanded>
              <template v-slot:day-content="{ day, attributes }">
                <div class="calendar-day-content" :class="{'is-today': day.isToday}">
                  <span class="day-label">{{ day.day }}</span>
                  <div class="calendar-events">
                   <p v-for="event in attributes" class="calendar-event" :key="event.key + day.day" :style="{'background-color': event.customData.backgroundColor, 'color': event.customData.textColor}">
                     <router-link v-if="event.customData.eventType != 'VacationShow'" class="text-xs leading-tight rounded-sm p-1 mt-0 mb-1"
                                  :style="{'color': event.customData.textColor}"
                                  :to="{name: event.customData.eventType, query: event.customData.query, state: {id: event.customData.eventId} }">
                       {{ event.customData.title }}
                     </router-link>
                     <a v-if="event.customData.eventType == 'VacationShow'" class="text-xs leading-tight rounded-sm p-1 mt-0 mb-1"
                        :style="{'color': event.customData.textColor}">{{ event.customData.title }}
                     </a>
                   </p>
                  </div>
                </div>
              </template>
            </Calendar>
          </div>
        </div>
      </div>
    </div>
  </div><!-- end of main-content -->

</template>

<script>
import {Calendar} from 'v-calendar';
import {mapState} from "vuex";

export default {
  components: {
    Calendar,
  },
  data() {
    return {
      dateFrom: '',
      dateTo: '',
      currentPage: {
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear(),
      },
      events: [],
      masks: {
        weekdays: 'WWW',
      },
    }
  },

  methods: {
    loadEvents() {
      this.$axios.get('calender?start=' + this.dateFrom + '&end=' + this.dateTo)
          .then(response => {
            this.events = response.data
          });
    },
    pageChange(pages) {
      const obj = pages[0];
      this.currentPage = {
        month: obj.month,
        year: obj.year,
      };
      this.dateFrom = `1-${obj.month}-${obj.year}`;
      this.dateTo = `30-${obj.month}-${obj.year}`;
      this.loadEvents()
    },
    changeMonth(offset) {
      const targetDate = new Date(this.currentPage.year, this.currentPage.month - 1 + offset, 1);
      this.$refs.calendar.move(targetDate);
    },
    goToToday() {
      this.$refs.calendar.move(new Date());
    }
  },
  mounted() {
    const now = new Date();
    this.pageChange([{month: now.getMonth() + 1, year: now.getFullYear()}]);
  },
  computed: {
    currentPageTitle() {
      return new Intl.DateTimeFormat(this.$i18n.locale, {
        month: 'long',
        year: 'numeric',
      }).format(new Date(this.currentPage.year, this.currentPage.month - 1, 1));
    },
    filterEvents() {
      if (this.events && this.events.length) {
        return [
          ...this.events.map(event => (
              {
                key: event.id,
                customData: {
                  title: event.title,
                  backgroundColor: event.backgroundColor,
                  textColor: event.textColor,
                  url: event.url,
                  allDay: event.allDay,
                  eventType: event.eventType,
                  eventId: event.eventId,
                  query: event.query || {},
                },
                dates: new Date(event.start.split('-')[2], event.start.split('-')[1] - 1, event.start.split('-')[0]),
              }
          )),
        ];
      }
      return [];
    },
    ...mapState('dashboard', {
      dashboardData : 'dashboardData',
    }),
    dayIndex() {
      let day = 1;
      if(this.dashboardData.country == 'TR') {
        day = 2;
      }
      return day
    }
  },
  watch: {
    '$i18n.locale': function () {
      if (this.dateFrom && this.dateTo) {
        this.loadEvents();
      }
    },
    dashboardData(newD, oldD) {
      const financialYearChanged = newD.selectFinancialYear != oldD.selectFinancialYear && oldD.selectFinancialYear;
      const academicYearChanged = newD.currentSessionAcademicYear != oldD.currentSessionAcademicYear && oldD.currentSessionAcademicYear;
      const branchChanged = newD.userActiveBranch != oldD.userActiveBranch && oldD.userActiveBranch;
      if (financialYearChanged || academicYearChanged || branchChanged) {
        if (this.dateFrom && this.dateTo) {
          this.loadEvents();
        }
      }
    },
  }
}

</script>

<style scoped>
/deep/ .custom-calendar.vc-container {
  --day-border: 1px solid #e8ecf2;
  --day-border-highlight: 1px solid #dce3ec;
  --day-width: 90px;
  --day-height: 112px;
  --weekday-bg: #f7f9fc;
  --weekday-border: 1px solid #e8ecf2;
  border: 1px solid #e8ecf2;
  border-radius: 0 0 14px 14px;
  box-shadow: 0 8px 24px rgba(28, 47, 74, 0.06);
  color: #344767;
  overflow: hidden;
  width: 100%;
}

/deep/ .custom-calendar.vc-container .vc-header {
  display: none;
}

/deep/ .custom-calendar.vc-container .vc-weeks {
  padding: 0;
}

/deep/ .custom-calendar.vc-container .vc-weekday {
  background: var(--weekday-bg);
  border-bottom: var(--weekday-border);
  border-top: var(--weekday-border);
  color: #526780;
  font-size: 14px;
  font-weight: 700;
  padding: 10px 0;
}

/deep/ .custom-calendar.vc-container .vc-day {
  background: #fff;
  color: #344767 !important;
  height: var(--day-height);
  min-width: var(--day-width);
  padding: 0;
  box-shadow: inset -1px -1px 0 #e8ecf2;
  text-align: initial;
  transition: background-color .2s ease;
}

/deep/ .custom-calendar.vc-container .vc-day:hover {
  background: #f9fbfd;
}

/deep/ .custom-calendar.vc-container .vc-day-dots {
  margin-bottom: 5px;
}

.calendar-toolbar {
  align-items: center;
  background: linear-gradient(135deg, #f8faff 0%, #f2f6fb 100%);
  border: 1px solid #e8ecf2;
  border-bottom: 0;
  border-radius: 14px 14px 0 0;
  display: flex;
  justify-content: space-between;
  padding: 12px 16px;
}

.calendar-toolbar__title {
  align-items: center;
  color: #253858;
  display: flex;
  font-size: 16px;
  font-weight: 700;
  gap: 8px;
}

.calendar-toolbar__title i {
  color: #4d7cbd;
}

.calendar-navigation {
  align-items: center;
  background: #fff;
  border-inline: 1px solid #e8ecf2;
  display: grid;
  grid-template-columns: 44px 1fr 44px;
  padding: 12px 18px;
}

.calendar-navigation__title {
  color: #253858;
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  text-transform: capitalize;
}

.calendar-navigation__arrow {
  align-items: center;
  background: #f1f4f8;
  border: 0;
  border-radius: 50%;
  color: #526780;
  cursor: pointer;
  display: inline-flex;
  height: 34px;
  justify-content: center;
  padding: 0;
  transition: background-color .2s ease, color .2s ease, transform .2s ease;
  width: 34px;
}

.calendar-navigation__arrow:last-child {
  justify-self: end;
}

.calendar-navigation__arrow:hover {
  background: #e4ebf4;
  color: #315f9b;
  transform: translateY(-1px);
}

.calendar-today-btn {
  background: #fff;
  border: 1px solid #d9e2ee;
  border-radius: 8px;
  color: #315f9b;
  cursor: pointer;
  font-size: 13px;
  font-weight: 700;
  padding: 7px 16px;
  transition: all .2s ease;
}

.calendar-today-btn:hover {
  background: #315f9b;
  border-color: #315f9b;
  color: #fff;
}

.calendar-day-content {
  height: 100%;
  overflow: hidden;
  padding: 8px;
}

.day-label {
  align-items: center;
  color: #526780;
  display: inline-flex;
  font-size: 13px;
  font-weight: 600;
  height: 26px;
  justify-content: center;
  width: 26px;
}

.calendar-day-content.is-today {
  background: #f4f8ff;
  box-shadow: inset 0 0 0 1px #b8d2f2;
}

.calendar-day-content.is-today .day-label {
  background: #3f73b5;
  border-radius: 50%;
  color: #fff;
}

.calendar-events {
  height: calc(100% - 30px);
  margin-top: 4px;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-color: #b8c5d5 transparent;
  scrollbar-width: thin;
}

.calendar-events::-webkit-scrollbar {
  width: 5px;
}

.calendar-events::-webkit-scrollbar-thumb {
  background: #b8c5d5;
  border-radius: 10px;
}

.calendar-events::-webkit-scrollbar-track {
  background: transparent;
}

.calendar-event {
  border-radius: 6px;
  line-height: 1.35;
  margin: 0 0 5px;
  overflow: hidden;
  padding: 3px 6px;
  text-overflow: ellipsis;
  transition: transform .15s ease, box-shadow .15s ease;
  white-space: nowrap;
}

.calendar-event:hover {
  box-shadow: 0 3px 8px rgba(32, 56, 85, 0.12);
  transform: translateY(-1px);
}

.calendar-event a {
  display: block;
  font-weight: 600;
  overflow: hidden;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 767px) {
  /deep/ .custom-calendar.vc-container {
    --day-height: 92px;
    --day-width: 70px;
    overflow-x: auto;
  }

  .calendar-day-content {
    padding: 5px;
  }

  .calendar-event {
    font-size: 10px;
    padding: 2px 4px;
  }
}
</style>
